/* eslint-disable */

class excelWorker {
  getWorkerCode() {
    importScripts("https://cdn.sheetjs.com/xlsx-0.18.10/package/dist/shim.min.js");
    importScripts("https://cdn.sheetjs.com/xlsx-0.18.10/package/dist/xlsx.full.min.js");
    
    onmessage = (e) => {
      if (Array.isArray(e.data['data'])) {
        generateExcelByCell(e.data['data']);
      } else {
        generateExcelTable(e.data['data'], e.data['options']);
      }
    }

    function generateExcelTable(e, options) {
      if (options == undefined) { options = {} }

      let ws = XLSX.utils.aoa_to_sheet([]);
      let header = Object.keys(e['value'][0]);
      let cell = XLSX.utils.decode_cell(e['cell']);
      cell['r'] += e['startRow'] + 1;
      e['value'].forEach((v, vi) => {
        header.forEach(h => {
          XLSX.utils.sheet_add_aoa(ws, [[v[h] ?? '']], { origin: cell });
          if (options['rowHighlight'] && options['tableTheme'] && vi % 2 == 0) {
            if (options['tableTheme']['row']) {
              ws[XLSX.utils.encode_cell(cell)].s = {
                fill: {
                  fgColor: options['tableTheme']['row']
                }
              }
            }
          }
          if (ws[XLSX.utils.encode_cell(cell)].s == undefined) { ws[XLSX.utils.encode_cell(cell)].s = {} }
          ws[XLSX.utils.encode_cell(cell)].s['alignment'] = {
            horizontal: options['rightAlign'].includes(cell['c']) ? 'right' : 'left'
          };
          cell['c']++;
        });
        cell['r']++;
        cell['c'] -= header.length;
      });
      
      postMessage({
        sheet: ws,
        header: header,
        headerStyle: e['headerStyle'],
        cell: e['cell']
      });
      // data.forEach(e => {
      //   if (Array.isArray(e['value'])) {
      //     let cell = XLSX.utils.decode_cell(e['cell']);
      //     let header = Object.keys(e['value'][0]);
      //     header.forEach(h => {
      //       XLSX.utils.sheet_add_aoa(ws, [[h || '']], { origin: cell });
      //       ws[XLSX.utils.encode_cell(cell)].s = e['headerStyle'];
      //       if (!ws[XLSX.utils.encode_cell(cell)].s) { ws[XLSX.utils.encode_cell(cell)].s = {} }
      //       if (options['tableTheme']) {
      //         ws[XLSX.utils.encode_cell(cell)].s['fill'] = {
      //           fgColor: this.rgbaToExcelColor(options['tableTheme'])
      //         };
      //       }
      //       cell['c']++;
      //     });
  
      //     cell['r']++;
      //     cell['c'] -= header.length;
      //     e['value'].forEach((v, i) => {
      //       let values = Object.values(v);
      //       values.forEach(val => {
      //         XLSX.utils.sheet_add_aoa(ws, [[val || '']], { origin: cell });
      //         if (options['rowHighlight'] && (i % 2 == 0)) {
      //           ws[XLSX.utils.encode_cell(cell)].s = {
      //             fill: {
      //               fgColor: options['tableTheme'] ? this.rgbaToExcelColor(options['tableTheme'].split(',').map(r => {
      //                 let val = Number(r);
      //                 if (val == 255) { return 255 }
      //                 else {
      //                   return val + 120 > 225 ? 225 : val + 120 < 175 ? 175 : val + 120;
      //                 }
      //               }).join(',')) : this.rgbaToExcelColor('226,228,255')
      //             }
      //           }
      //         }
      //         cell['c']++;
      //       });
            
      //       cell['r']++;
      //       cell['c'] -= header.length;
      //     })
      //   } else {
      //     XLSX.utils.sheet_add_aoa(ws, [[e['value'] || '']], { origin: e['cell'] });
      //     if (e['style']) {
      //       ws[e['cell']].s = e['style'];
      //     }
      //   }
      // });
    }

    function generateExcelByCell(data) {
      let ws = XLSX.utils.aoa_to_sheet([]);
      data.forEach(e => {
        XLSX.utils.sheet_add_aoa(ws, [[e['value'] || '']], { origin: e['cell'] });
        if (e['style']) {
          ws[e['cell']].s = e['style'];
        }
      })

      postMessage({ sheet: ws });
    }
  }
  createWorker = () => {
    let code = '';
    if (process.env['NODE_ENV'] == 'development') {
      code = this.getWorkerCode.toString().substring(30, this.getWorkerCode.toString().length - 2).trim();
    } else {
      code = this.getWorkerCode.toString().substring(11, this.getWorkerCode.toString().length - 1).trim();
    }
    return new Worker(URL.createObjectURL(new Blob([code])));
  }

  getMaxMinCode() {
    onmessage = (e) => {
      getMaxMin(e.data);
    }

    function getMaxMin(e) {
      let maxValue = [];
      let minValue = [];
      e.forEach(n => {
        let max = -Infinity;
        let min = Infinity;
        n.forEach(v => {
          if (v > max) { max = v }
          if (v < min) { min = v }
        })
        maxValue.push(max);
        minValue.push(min);
      })

      let finalMax = -Infinity;
      let finalMin = Infinity;
      maxValue.forEach(m => {
        if (m > finalMax) { finalMax = m }
      })
      minValue.forEach(m => {
        if (m < finalMin) { finalMin = m }
      })

      postMessage({
        max: finalMax,
        min: finalMin
      })
    }
  }
  createMaxMinWorker = () => {
    let code = '';
    if (process.env['NODE_ENV'] == 'development') {
      code = this.getMaxMinCode.toString().substring(30, this.getMaxMinCode.toString().length - 2).trim();
    } else {
      code = this.getMaxMinCode.toString().substring(11, this.getMaxMinCode.toString().length - 1).trim();
    }
    return new Worker(URL.createObjectURL(new Blob([code])));
  }
}

export default excelWorker;